module.exports = __webpack_public_path__ + "static/media/settings-default.647cdc79.svg";